import React from 'react';
import {
  Box, Collapse, Divider, Grid, IconButton, Typography,
} from '@mui/material';
import { DisplayStringTrans } from '@gamiphy/react-i18n';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Faq } from '@gamiphy/bl/faq';
import { App } from '@gamiphy/bl/app';

type Props = {
  data: Faq,
  app?: App,
}

const FaqItem: React.FC<Props> = ({ data, app }) => {
  const { question, answer } = data;
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <Box mb={3}>
      <Grid container wrap="nowrap" alignItems="center">
        <Grid flex={1}>
          <Typography variant="subtitle1">
            <DisplayStringTrans displayString={question} values={{ appName: app?.name }} />
          </Typography>
        </Grid>
        <Grid>
          <IconButton disableRipple onClick={() => setIsOpen((prev) => (!prev))}>
            {isOpen ? (
              <ExpandLessIcon sx={{
                fontSize: '3rem',
              }}
              />
            ) : (
              <ExpandMoreIcon sx={{
                fontSize: '3rem',
              }}
              />
            )}
          </IconButton>
        </Grid>
      </Grid>
      <Divider />
      <Collapse timeout={300} in={isOpen}>
        <Box py={2}>
          <Typography
            variant="body2"
            sx={{ lineHeight: '3rem' }}
          >
            <DisplayStringTrans displayString={answer} values={{ appName: app?.name }} />
          </Typography>
        </Box>
      </Collapse>
    </Box>
  );
};

export default FaqItem;
